var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLogin)?_c('hitvBindLogin',{staticClass:"mp-login",attrs:{"fetchParams":_vm.fetchParams,"size":"mini","visible":_vm.showLogin},on:{"update:visible":function($event){_vm.showLogin=$event},"handleLoginSuccess":_vm.handleLoginSuccess}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }